/**
 * 메모 목록 — 고정 먼저, 그다음 일어난 날 최신순(서버 정렬 그대로, 요청서 N1).
 * 개요 탭의 「최근 메모」(앞 몇 개)와 메모 탭(전부)이 같이 쓴다. 쓰기(N2·N3)는 P3.
 */
import React from 'react';
import { Pin } from 'lucide-react';
import { ToneBadge } from '../ui';

function NoteList({ notes, limit = null }) {
  const shown = limit ? notes.slice(0, limit) : notes;
  if (shown.length === 0) return <p className="py-2 text-xs text-gray-500">메모가 없습니다.</p>;
  return (
    <ul className="divide-y divide-gray-100">
      {shown.map((n) => (
        <li key={n.id ?? `${n.occurred_on}-${n.body}`} className="flex gap-2 py-2 text-xs">
          <span className="w-12 shrink-0 font-mono text-gray-500">{n.occurred_on ? n.occurred_on.slice(5).replace('-', '/') : '—'}</span>
          <div className="min-w-0 flex-1">
            <p className="whitespace-pre-wrap break-words text-gray-900">
              {n.is_pinned && <Pin aria-label="고정" className="mr-1 inline size-3 text-primary" />}
              {n.category && <span className="text-gray-500">{n.category} · </span>}
              {n.body}
              {n.is_issue && <span className="ml-1 align-middle"><ToneBadge tone="danger">주요 이슈</ToneBadge></span>}
            </p>
          </div>
          {n.author_name && <span className="shrink-0 text-gray-400">{n.author_name}</span>}
        </li>
      ))}
    </ul>
  );
}

export default NoteList;
